import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { useCallback } from 'react'
import { getEffectiveFromShift } from './getEffectiveFromShift'

/**
 * Moves the effective date within the phase the amendment split, keeping any
 * pricing edits. Returns false when the date can't move that way, so the
 * caller can fall back to rebuilding the phases.
 */
export const useShiftAmendmentEffectiveFrom = () => {
  const cubeContext = useCubeContext()
  const amendment = cubeContext.queries.rawData.data.quote.amendment
  const orderedPhases = cubeContext.queries.orderedPhases

  return useCallback(
    (newEffectiveFrom: Date): boolean => {
      const shift =
        amendment &&
        getEffectiveFromShift({ orderedPhases, amendment, newEffectiveFrom })

      if (!shift) {
        return false
      }

      cubeContext.mutators.updateData({
        quote: {
          amendment: {
            effectiveFrom: newEffectiveFrom
          }
        },
        phases: shift
      })

      return true
    },
    [amendment, cubeContext.mutators, orderedPhases]
  )
}
